<template>
  <card>
    <div class="container">
      <div class="row qc-only">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-9">
              <h2>QC only</h2>
              <el-select
                v-model="selectedShopId"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="Please enter a keyword"
                :remote-method="remoteMethod"
                :loading="loading"
                @change="selectChange"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="row">
            商店：
            <p contenteditable @input="onInput($event, 'name')">
              {{ displayData.name }}
            </p>
            ({{ displayData.isUploaded ? "已上傳" : "未上傳" }})
          </div>
        </div>
        <div class="col-sm-12">
          <div class="row">
            電話：
            <p contenteditable @input="onInput($event, 'phone')">
              {{ displayData.phone }}
            </p>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="row">
            地址：
            <p contenteditable @input="onInput($event, 'address')">
              {{ displayData.address }}
            </p>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="row">
            google轉換地址：
            <p>{{ googleAddress }}</p>
            <button @click="transAddress">開始轉換</button>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-6">
              <button @click="upload">以原本地址上傳</button>
            </div>
            <div class="col-sm-6">
              <button @click="uploadGoogle">以google地址上傳</button>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="row">
            <p>{{ results }}</p>
          </div>
        </div>
      </div>

      <br />
      <div class="row">
        <div class="col-sm-12">
          <el-radio v-model="selectedSi" label="quickclick"
            >quickclick</el-radio
          >
          <el-radio v-model="selectedSi" label="lifeplus">lifeplus</el-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="row">
            <label class="col-sm-1 col-form-label">查詢商店</label>
            <div class="col-sm-8">
              <fg-input placeholder="" v-model="getStoreIdInput"></fg-input>
              <el-button @click.prevent="_getStore(getStoreIdInput)"
                >查詢</el-button
              >
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              {{ getStoreResults }}
            </div>
          </div>
        </div>
      </div>

      <br />
      <div class="row">
        <div class="col-sm-12">
          <div class="row">
            <label class="col-sm-1 col-form-label">刪除商店</label>
            <div class="col-sm-8">
              <fg-input placeholder="" v-model="delStoreIdInput"></fg-input>
              <el-button @click.prevent="_delStore(delStoreIdInput)"
                >刪除</el-button
              >
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              {{ delStoreResults }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import axios from "axios";
import { fetchGoogleAddress, fetchShopsByName, getStore } from "src/javascripts/generalPages/fetchData";
import { postLineSpot } from "src/javascripts/generalPages/postData";
import { delStore } from "src/javascripts/generalPages/deleteData";
import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";
import swal from "sweetalert2";

export default {
  data() {
    return {
      selectedSi: "quickclick",
      delStoreResults: "",
      getStoreResults: "",
      getStoreIdInput: "",
      delStoreIdInput: "",
      displayData: {
        name: "",
        phone: "",
        address: "",
        isUploaded: false
      },
      name: "hello world",
      phone: "0987654321",
      address: "台北市民生東路三段",
      googleAddress: "",
      results: "",
      options: [],
      selectedShopId: 0,
      list: [],
      loading: false,
      states: [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming"
      ]
    };
  },
  mounted() {
    this.list = this.states.map(item => {
      return { value: `value:${item}`, label: `label:${item}` };
    });
  },
  watch: {
    selectedSi: function(val, old) {
      console.log(val);
    }
  },
  methods: {
    _getStore(id) {
      console.log("getStore: ", id);
      // console.log(getStore)
      let that = this;
      getStore(id, that.selectedSi)
        .then(getStoreRes => {
          console.log("getStoreRes: ", getStoreRes);
          that.getStoreResults = getStoreRes.data;
        })
        .catch(getStoreErr => {
          console.log("getStoreErr: ", getStoreErr);
          that.getStoreResults = getStoreErr.data;
        });
    },
    _delStore(id) {
      console.log("_delStore: ", id);
      let that = this;
      swal.fire({
        title: `確定要將商店號碼「${id}」從LINE SPOT中移除嗎？`,
        buttonsStyling: true,
        // confirmButtonClass: "btn btn-success btn-fill",
        showCancelButton: true,
        confirmButtonColor: "#f96332",
        cancelButtonColor: "#cccccc",
        confirmButtonText: "刪除"
      }).then(res => {
        console.log("res: ", res);
        if (res.value) {
          delStore(id, that.selectedSi)
            .then(delStoreRes => {
              console.log("delStoreRes: ", delStoreRes);
              that.delStoreResults = delStoreRes.data;
            })
            .catch(delStoreErr => {
              console.log("delStoreErr: ", delStoreErr);
              that.delStoreResults = delStoreErr.data;
            });
        }
      });
    },
    onInput(e, type) {
      console.log(e.target.innerText);
      console.log(type);
      if (type == "name") {
        this.displayData.name = e.target.innerText;
      } else if (type == "phone") {
        this.displayData.phone = e.target.innerText;
      } else if (type == "address") {
        this.displayData.address = e.target.innerText;
      }
    },
    transAddress: async function() {
      console.log("address: ", this.displayData.address);
      let address = this.displayData.address;
      let fetchGoogleAddressRes = await fetchGoogleAddress(address);
      console.log(fetchGoogleAddressRes);
      console.log(fetchGoogleAddressRes.data.googleAddress);
      this.googleAddress = fetchGoogleAddressRes.data.googleAddress;
    },
    upload: function() {
      console.log(this.displayData);
      if (this.displayData.value) {
        let accountId = this.displayData.value;
        let address = this.displayData.address;
        let postLineSpotData = {
          accountId,
          address
        };
        postLineSpot(postLineSpotData, process.env.VUE_APP_SI)
          .then(res => {
            console.log("res: ", res);
            console.log("res: ", res);
            this.results = res.data;
          })
          .catch(err => {
            console.log("err: ", err);
          });
      }
    },
    uploadGoogle: function() {
      console.log(this.displayData);
      console.log(this.googleAddress);
      if (this.displayData.value) {
        let accountId = this.displayData.value;
        let address = this.displayData.address;
        let postLineSpotData = {
          accountId,
          address
        };
        postLineSpot(postLineSpotData, process.env.VUE_APP_SI)
          .then(res => {
            console.log("res: ", res);
            this.results = res.data;
          })
          .catch(err => {
            console.log("err: ", err);
          });
      }
    },
    async remoteMethod(keyword) {
      if (keyword !== "") {
        this.options = [];
        this.googleAddress = "";
        let fetchShopsRes = await fetchShopsByName(keyword);
        console.log("fetchShopsRes: ", fetchShopsRes);
        if (fetchShopsRes.data.results) {
          this.loading = false;
          this.list = fetchShopsRes.data.results.map(item => {
            return {
              value: `${item.id}`,
              label: `${item.name}`,
              name: item.name,
              phone: item.phone,
              address: item.address,
              isUploaded: item.isUploaded
            };
          });

          this.options = this.list.filter(item => {
            return item.label.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
          });
        }
      } else {
        this.options = [];
      }
    },
    selectChange() {
      this.options = [];
      this.displayData = {
        name: "",
        phone: "",
        address: "",
        isUploaded: false
      };
      if (this.selectedShopId.length > 0) {
        console.log(this.selectedShopId);
        console.log(this.list);
        let accountId = this.selectedShopId[0];
        let shopData = this.list.find(
          item => item.value == this.selectedShopId
        );
        console.log(shopData);
        this.displayData = shopData;
      }
    }
  }
};
</script>

<style>
.qc-only {
  background-color: #F8C1B8;
}
</style>
